// removed by extract-text-webpack-plugin
module.exports = {"root":"_9k-mX","content":"_wiKx8"};


//////////////////
// WEBPACK FOOTER
// ./app/components/authCard/BasicCard/BasicCard.scss
// module id = 1149
// module chunks = 1